import Modal from 'react-modal';
import axios from 'axios';
import Swal from 'sweetalert2';

const fieldClass =
    'rounded-lg block w-full px-3 py-2 text-base sm:text-sm text-gray-800 dark:text-gray-200 bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-600 focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary transition-colors';

const labelClass =
    'block text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1.5 text-left';

const PaymentMethodForm = ({ openForm, closeForm, data, header }) => {
    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const payload = Object.fromEntries(formData.entries());

        try {
            if (data?.paymentMethodID) {
                await axios.patch(`api/payment-method/${data.paymentMethodID}`, payload, header);
            } else {
                await axios.post('api/payment-method', payload, header);
            }
            closeForm();
            Swal.fire({
                icon: 'success',
                title: 'Berhasil',
                text: 'Data metode pembayaran berhasil disimpan!',
                confirmButtonColor: '#4569ab',
                timer: 1600,
                showConfirmButton: true,
            });
        } catch (error) {
            console.error('Error submitting payment method:', error);
            Swal.fire({
                icon: 'error',
                title: 'Gagal',
                text: 'Terjadi kesalahan saat menyimpan data!',
                confirmButtonColor: '#4569ab',
            });
        }
    };

    return (
        <Modal
            isOpen={openForm}
            onRequestClose={closeForm}
            contentLabel="Metode Pembayaran"
            ariaHideApp={false}
            className="fixed inset-0 z-50 flex items-center justify-center p-4 outline-none"
            overlayClassName="fixed inset-0 z-50 bg-black/50 backdrop-blur-[2px]"
            shouldCloseOnOverlayClick={true}
        >
            <form
                key={data?.paymentMethodID || 'new'}
                onSubmit={handleSubmit}
                className="relative flex w-full max-w-md max-h-[90vh] flex-col overflow-hidden rounded-2xl border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 shadow-2xl"
            >
                <div className="relative flex shrink-0 items-center justify-between border-b border-gray-100 dark:border-gray-700 px-5 py-4">
                    <div className="text-left">
                        <p className="text-[10px] font-bold uppercase tracking-wider text-primary dark:text-primary-on-dark">
                            Payment Method
                        </p>
                        <h2 className="text-lg font-bold text-gray-900 dark:text-white">
                            {data?.paymentMethodID ? 'Edit Metode' : 'Tambah Metode'}
                        </h2>
                    </div>
                    <button
                        type="button"
                        onClick={closeForm}
                        className="flex h-8 w-8 items-center justify-center rounded-lg text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-700 text-xl leading-none"
                        aria-label="Tutup"
                    >
                        ×
                    </button>
                </div>

                <div className="flex-1 space-y-4 overflow-y-auto px-5 py-4">
                    <div>
                        <label htmlFor="bank" className={labelClass}>
                            Bank <sup className="text-red-500">*</sup>
                        </label>
                        <input
                            id="bank"
                            type="text"
                            name="bank"
                            placeholder="cth. BNI"
                            className={fieldClass}
                            required
                            defaultValue={data?.bank || ''}
                        />
                    </div>
                    <div>
                        <label htmlFor="rekening_number" className={labelClass}>
                            Nomor Rekening <sup className="text-red-500">*</sup>
                        </label>
                        <input
                            id="rekening_number"
                            type="text"
                            name="rekening_number"
                            inputMode="numeric"
                            placeholder="Nomor rekening"
                            className={fieldClass}
                            required
                            defaultValue={data?.rekening_number || ''}
                        />
                    </div>
                    <div>
                        <label htmlFor="owner" className={labelClass}>
                            Pemilik Rekening <sup className="text-red-500">*</sup>
                        </label>
                        <input
                            id="owner"
                            type="text"
                            name="owner"
                            placeholder="Nama pemilik"
                            className={fieldClass}
                            required
                            defaultValue={data?.owner || ''}
                        />
                    </div>
                </div>

                <div className="flex shrink-0 gap-2 border-t border-gray-100 dark:border-gray-700 px-5 py-4">
                    <button
                        type="button"
                        onClick={closeForm}
                        className="flex-1 rounded-lg bg-gray-100 dark:bg-gray-700 py-2.5 text-sm font-semibold text-gray-700 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
                    >
                        Batal
                    </button>
                    <button
                        type="submit"
                        className="flex-1 btn-primary"
                    >
                        Simpan
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default PaymentMethodForm;
